import { QAFooter, QAItem, QATitle, QAWrapper } from "../../../global/QA";

export const PaymentQASection = () => {
  return (
    <QAWrapper>
      <QATitle>We&rsquo;re here to answer your questions.</QATitle>

      <QAItem question={"Can I cancel my subscription at any time?"}>
        Absolutely! You can cancel your subscription anytime with no strings
        attached. Your access to premium features will end on the next billing
        cycle.
      </QAItem>

      <QAItem question={"Can I switch between membership tiers?"}>
        Yes, you can easily upgrade or downgrade your plan at any time. If you
        upgrade, the change will take effect immediately and you&apos;ll be
        charged a prorated amount for the remaining days of your billing cycle.
        If you downgrade, the change will take effect at the end of your current
        billing cycle.
      </QAItem>

      <QAItem
        question={
          "How does training plan access work with the different membership tiers?"
        }
      >
        Each membership tier gives you access to a certain number of training
        plans. For example, the Silver tier gives you access to 3 plans, but you
        can only have 2 active at a time. You can easily switch between your
        available plans as often as you like, allowing you to explore different
        training styles and find what works best for you.
      </QAItem>

      <QAItem
        question={"I'm not sure which plan is right for me. Can you help?"}
      >
        Definitely! We&apos;re happy to help you choose the plan that best fits
        your needs and goals. Reach out to our customer support team for advice.
      </QAItem>

      <QAFooter />
    </QAWrapper>
  );
};
